import { EstablecimientoComercioService } from './../../../prestador/establecimiento-comercio/establecimiento-comercio.service';
import { CamaraComercioEntry } from './../../../../../../../shared/entrys/camara-comercio';
import { SubCategoriaEntry } from "./../../../../../../../shared/entrys/sub-categoria.entry";
import { SolicitudEditRegistroModel } from "./../../../../../../../shared/models/solicitud-edit-registro-model";
import { DatoSolicitudSharedModel } from "./../../../../../../../shared/models/dato-solicitud-shared.model";
import { ConfirmeValidators } from "./../../../../../../../shared/directives/validators/confirme-validators";
import { Validators } from "@angular/forms";
import { ActualizarRegistrosService } from "./actualizar-registros.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AlertsService } from "./../../../../../../../shared/services/alerts.service";
import { FormBuilder } from "@angular/forms";
import { FormGroup } from "@angular/forms";
import { Component, OnInit } from "@angular/core";
import * as internal from "events";
import { StringLiteralType } from "typescript";

@Component({
  selector: "app-actualizar-registros-rnt",
  templateUrl: "./actualizar-registros-rnt.component.html",
  styleUrls: ["./actualizar-registros-rnt.component.scss"],
})
export class ActualizarRegistrosRntComponent implements OnInit {
  datoSolicitudSharedModel2 = new DatoSolicitudSharedModel();
  solicitudR = new SolicitudEditRegistroModel();
  informacionEstablecimiento2: any;
  formularioDatos: FormGroup;
  labelTextA: string;
  sub_categoria_id: number;
  aux: string;
  selectedOption: any = null;
  actEdit:boolean = false;
  actSincronizar:boolean = false;

  subCategorias: Array<SubCategoriaEntry>;
  activeFormSel: boolean = true;
  selectvarl: any;

  camarasLista: Array<CamaraComercioEntry>;
  constructor(
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private alertsService: AlertsService,
    private ServiceActualizar: ActualizarRegistrosService,
    private establecimientoComercioService: EstablecimientoComercioService
  ) { }

  ngOnInit() {
    this.formulario2();
    this.setSelectedFilter2();
    this.establecimientoComercioService.getCamaras().subscribe(resultado => {
			if (resultado) {
				this.camarasLista = resultado.data as Array<CamaraComercioEntry>;
			}
		});
  }

  formulario2() {
    this.formularioDatos = this.formBuilder.group({
      codigo: ["", [Validators.required, ConfirmeValidators.numberValidator]],
      tipo_filtro: [1, Validators.required],
      codigo_camara:[""]
    });
  }

  setSelectedFilter2(): void {
    switch (this.formularioDatos.get("tipo_filtro").value) {
      case 1:
        this.labelTextA = "Ingrese el número de RNT";
        this.aux = "rnt";
        this.ClearValidatorFormulario();
        break;
      case 2:
        this.formularioDatos.get('codigo_camara').setValidators([Validators.required]);
        this.labelTextA = "Ingrese el número de Radicado";
        this.aux = "radicado";
        break;
      default:
        this.labelTextA = "Seleccione un filtro";
        break;
    }
  }


ClearValidatorFormulario(){
  this.formularioDatos.get('codigo_camara').clearValidators();
  this.formularioDatos.get('codigo_camara').setValidators(null);
  this.formularioDatos.get('codigo_camara').reset();
  this.formularioDatos.get('codigo_camara').setErrors(null);
}

  ClickBuscar() {
    if (this.aux === "rnt") {
        this.sub_categoria_id = null;
        this.selectedOption = null;
        this.solicitudR.CodigoRadicado = null;
        this.solicitudR.codigo_camara = null;
        this.solicitudR.CodigoRNT = this.formularioDatos.get("codigo").value;
        this.getInformacion(this.solicitudR);
    }
    else if(this.aux="radicado")
    {
      this.sub_categoria_id = null;
      this.solicitudR.CodigoRNT = null;
      this.solicitudR.CodigoRadicado = this.formularioDatos.get("codigo").value;
      this.solicitudR.codigo_camara = this.formularioDatos.get("codigo_camara").value;
      this.getInformacion(this.solicitudR);
    }
  }

  getInformacion(solicitud: SolicitudEditRegistroModel) {

    this.ServiceActualizar.getInformacionBasica(solicitud).subscribe(
      (response) => {
        if (response.result && response.data && response.data.length === 1) {
            this.informacionEstablecimiento2 = response.data[0];
            this.obtenerSubCatagoriaPorEstablecimiento();
            this.solicitudR.CodigoRNT = null;
            this.formularioDatos.get("codigo").reset();
            this.capturarSelect();
            this.activeEdit(response.data[0]);
            this.activeSyncronizar(response.data[0]);
            console.log(response.data);

        } else {
            this.informacionEstablecimiento2 = null;
            this.solicitudR.CodigoRNT = null;
            this.formularioDatos.get("codigo").reset();
        }
      }
    );
  }

  refresh() {

    if (this.informacionEstablecimiento2.codigo_rnt) {
      this.solicitudR.CodigoRadicado = null;
      this.solicitudR.codigo_camara = null;
      this.solicitudR.CodigoRNT = this.informacionEstablecimiento2.codigo_rnt;

    } else {
      this.solicitudR.CodigoRNT = null;
      this.solicitudR.CodigoRadicado = this.informacionEstablecimiento2.numero_radicacion;
      this.solicitudR.codigo_camara = this.informacionEstablecimiento2.codigo_camara;
    }

    this.getInformacion(this.solicitudR);
  }

  obtenerSubCatagoria(categoria_Id: number) {
    if (categoria_Id) {
      this.ServiceActualizar.getSubcategoria(categoria_Id).subscribe(
        (response) => {
          if (response.result) {
            this.subCategorias = response.data as Array<SubCategoriaEntry>;
            console.log(response.data);
          } else {
            this.subCategorias = [];
          }
        }
      );
    } else {
      this.subCategorias = [];
    }
  }

  obtenerSubCatagoriaPorEstablecimiento() {
    this.solicitudR.Categoria_Id =
      this.informacionEstablecimiento2.Categoria_Id;
    this.solicitudR.codigo_camara =
      this.informacionEstablecimiento2.codigo_camara;
    this.solicitudR.establecimiento_Id =
      this.informacionEstablecimiento2.establecimiento_Id;
    this.solicitudR.tipo_rnt_id = this.informacionEstablecimiento2.tipo_rnt_id;
    this.solicitudR.tipo_solicitud_id = this.informacionEstablecimiento2.tipo_solicitud_id;
    this.solicitudR.rnt_id = this.informacionEstablecimiento2.rnt_id;
    if (this.solicitudR.Categoria_Id) {
      this.ServiceActualizar.getSubcategoriaPorEstablecimiento(
        this.solicitudR
      ).subscribe((response) => {
        if (response.result) {
          this.subCategorias = response.data as Array<SubCategoriaEntry>;
          console.log(response.data);
        } else {
          this.subCategorias = [];
        }
      });
    } else {
      this.subCategorias = [];
    }
  }

  UpdateSubCategoria() {
    if (this.activeFormSel) {
      this.activeFormSel = false;
    } else {
      this.activeFormSel = true;
    }
  }

  capturarSelect() {
    this.selectvarl = this.selectedOption;
  }

  UpdateFormulario() {

    if (this.aux === "rnt") {
      this.solicitudR.CodigoRadicado = null;
      this.solicitudR.rnt_id = null;
      this.solicitudR.CodigoRNT = this.informacionEstablecimiento2.codigo_rnt;

    } else {

      this.solicitudR.CodigoRNT = null;
      this.solicitudR.rnt_id = this.informacionEstablecimiento2.rnt_id;
      this.solicitudR.CodigoRadicado = this.informacionEstablecimiento2.numero_radicacion;
    }

    this.solicitudR.sub_categoria_id = this.selectvarl;
    this.solicitudR.solicitud_id = this.informacionEstablecimiento2.solicitud_id;
    this.solicitudR.detalle_solicitud_id = this.informacionEstablecimiento2.detalle_solicitud_id;
    this.ServiceActualizar.updateInfGeneral(this.solicitudR).subscribe(
      (response) => {
        if (response.result) {
          this.UpdateSubCategoria();
          this.refresh();
        }
      }
    );
  }

  SincronizarPrestador() {
    this.ServiceActualizar.sincronizarEnSolicitud({
      matricula: this.informacionEstablecimiento2.matricula,
      codigo_camara:this.informacionEstablecimiento2.codigo_camara,
    }).subscribe((infoSync) => {
      if (infoSync.result) {
        this.refresh();
        this.alertsService.
        success('Se sincronizaron los datos de prestador de forma satifactoria', null, null);
      }
    });
  }

  activeEdit(list:any){
    if (
       (list.tipo_solicitud_id === 1 && list.estado_solicitud_id === 4)
    || (list.tipo_solicitud_id === 2 && list.estado_solicitud_id === 4)
    || (list.tipo_solicitud_id === 2 && list.estado_solicitud_id === 3)
    ) {

        this.actEdit = true;

       } else {

       this.actEdit = false;

       }
  }

  activeSyncronizar(list:any){
    if (
       (list.tipo_solicitud_id === 1 && list.estado_solicitud_id === 3)
    || (list.tipo_solicitud_id === 1 && list.estado_solicitud_id === 4)
    || (list.tipo_solicitud_id === 2 && list.estado_solicitud_id === 3)
    || (list.tipo_solicitud_id === 2 && list.estado_solicitud_id === 4)
    ) {

        this.actSincronizar = true;

       } else {

       this.actSincronizar = false;

       }
  }
}
